import script from "./NeteaseActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./NeteaseActivity.vue?vue&type=script&setup=true&lang=js"

import "./NeteaseActivity.vue?vue&type=style&index=0&id=663cfe5b&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-663cfe5b"]])

export default __exports__